export default Object.freeze({
  Nuevo: 1,
  Aprobado: 2,
  Denegado: 3,
  DocumentosSometidos: 4,
});
